// Import your existing config exports
import { API_BASE_URL, AUTH_TOKEN_KEY } from '../config';

// Simulate API delay
const delay = (ms = 500) => new Promise(resolve => setTimeout(resolve, ms));

// API Mode - CHANGED TO 'real' FOR LIVE DATA
const API_MODE = 'real';  // ← CHANGED FROM 'mock'

// Mock Data (keeping for fallback/testing)
const mockData = {
  admin: {
    _id: '1',
    firstName: 'Admin',
    lastName: 'User',
    email: 'admin@helpsum.com',
    role: 'admin',
  },
  merchants: [
    { 
      id: '1', 
      name: 'Tech Haven Store', 
      owner: 'John Smith', 
      email: 'john@techhaven.com', 
      phone: '+1 (555) 123-4567', 
      category: 'Electronics', 
      location: 'New York, USA', 
      revenue: '$45,230', 
      status: 'pending', 
      rating: 4.8, 
      joinDate: '2024-12-15', 
      description: 'Leading electronics retailer specializing in consumer tech.', 
      documents: ['Business License', 'Tax ID', 'Bank Statement'] 
    },
    { 
      id: '2', 
      name: 'Fashion Boutique Co.', 
      owner: 'Sarah Johnson', 
      email: 'sarah@fashionboutique.com', 
      phone: '+1 (555) 234-5678', 
      category: 'Fashion', 
      location: 'Los Angeles, USA', 
      revenue: '$38,540', 
      status: 'approved', 
      rating: 4.9, 
      joinDate: '2024-11-20', 
      description: 'Premium fashion boutique offering designer clothing.', 
      documents: ['Business License', 'Tax ID'] 
    },
    { 
      id: '3', 
      name: 'Gourmet Kitchen', 
      owner: 'Michael Chen', 
      email: 'michael@gourmetkitchen.com', 
      phone: '+1 (555) 345-6789', 
      category: 'Food & Beverage', 
      location: 'San Francisco, USA', 
      revenue: '$32,890', 
      status: 'pending', 
      rating: 4.7, 
      joinDate: '2024-12-18', 
      description: 'Artisan food marketplace with organic products.', 
      documents: ['Business License', 'Health Permit', 'Tax ID'] 
    },
    { 
      id: '4', 
      name: 'Digital Solutions Pro', 
      owner: 'Emma Wilson', 
      email: 'emma@digitalsolutions.com', 
      phone: '+1 (555) 456-7890', 
      category: 'Services', 
      location: 'Chicago, USA', 
      revenue: '$52,120', 
      status: 'approved', 
      rating: 4.9, 
      joinDate: '2024-10-05', 
      description: 'Professional digital marketing and web services.', 
      documents: ['Business License', 'Tax ID', 'Insurance'] 
    },
    { 
      id: '5', 
      name: 'Urban Outfitters Hub', 
      owner: 'David Brown', 
      email: 'david@urbanoutfitters.com', 
      phone: '+1 (555) 567-8901', 
      category: 'Fashion', 
      location: 'Miami, USA', 
      revenue: '$28,450', 
      status: 'rejected', 
      rating: 4.2, 
      joinDate: '2024-12-10', 
      description: 'Trendy urban fashion retailer for young adults.', 
      documents: ['Business License'] 
    },
    { 
      id: '6', 
      name: 'Home Essentials', 
      owner: 'Lisa Martinez', 
      email: 'lisa@homeessentials.com', 
      phone: '+1 (555) 678-9012', 
      category: 'Home & Garden', 
      location: 'Seattle, USA', 
      revenue: '$41,890', 
      status: 'pending', 
      rating: 4.6, 
      joinDate: '2024-12-16', 
      description: 'Complete home furnishing and decor store.', 
      documents: ['Business License', 'Tax ID', 'Certificates'] 
    }
  ],
  dashboardStats: {
    totalMerchants: 1284,
    totalRevenue: 895432,
    totalOrders: 12567,
    pendingApprovals: 24,
    recentUsers: 156,
    todayUsers: 23,
    completedJobs: 10543
  },
  notifications: [
    { 
      id: '1', 
      type: 'merchant', 
      title: 'New Merchant Application', 
      message: 'Tech Haven Store submitted an application', 
      time: '2 minutes ago', 
      read: false, 
      category: 'application' 
    },
    { 
      id: '2', 
      type: 'payment', 
      title: 'Payment Received', 
      message: 'Digital Solutions Pro - $2,450 payment processed', 
      time: '15 minutes ago', 
      read: false, 
      category: 'transaction' 
    },
    { 
      id: '3', 
      type: 'system', 
      title: 'System Update', 
      message: 'Platform updated to version 2.4.1', 
      time: '1 hour ago', 
      read: true, 
      category: 'system' 
    },
    { 
      id: '4', 
      type: 'merchant', 
      title: 'Merchant Approved', 
      message: 'Fashion Boutique Co. has been approved', 
      time: '2 hours ago', 
      read: true, 
      category: 'approval' 
    },
    { 
      id: '5', 
      type: 'alert', 
      title: 'Security Alert', 
      message: 'New login from unknown device detected', 
      time: '3 hours ago', 
      read: false, 
      category: 'security' 
    },
    { 
      id: '6', 
      type: 'payment', 
      title: 'Payout Completed', 
      message: 'Monthly payout of $45,230 completed', 
      time: '5 hours ago', 
      read: true, 
      category: 'transaction' 
    },
    { 
      id: '7', 
      type: 'merchant', 
      title: 'Document Uploaded', 
      message: 'Gourmet Kitchen uploaded tax documents', 
      time: '6 hours ago', 
      read: true, 
      category: 'document' 
    },
    { 
      id: '8', 
      type: 'system', 
      title: 'Maintenance Scheduled', 
      message: 'System maintenance on Dec 25, 2024', 
      time: '1 day ago', 
      read: true, 
      category: 'system' 
    },
    { 
      id: '9', 
      type: 'alert', 
      title: 'High Transaction Volume', 
      message: 'Unusual activity detected on account #4521', 
      time: '1 day ago', 
      read: false, 
      category: 'security' 
    },
    { 
      id: '10', 
      type: 'merchant', 
      title: 'Application Rejected', 
      message: 'Urban Outfitters Hub application rejected', 
      time: '2 days ago', 
      read: true, 
      category: 'rejection' 
    }
  ],
  // NEW: Mock data for Transaction Management
  transactions: [
    {
      id: 'TXN-2024-001',
      merchant: 'Tech Haven Store',
      customer: 'John Doe',
      amount: 245.50,
      status: 'completed',
      type: 'payment',
      date: '2024-01-28 14:32',
      paymentMethod: 'Credit Card',
      cardLast4: '4242',
      description: 'Service booking payment',
      refundable: true
    },
    {
      id: 'TXN-2024-002',
      merchant: 'Fashion Boutique',
      customer: 'Jane Smith',
      amount: 89.99,
      status: 'pending',
      type: 'payment',
      date: '2024-01-28 13:15',
      paymentMethod: 'PayPal',
      cardLast4: null,
      description: 'Product purchase',
      refundable: false
    }
  ],
  // NEW: Mock data for Support Tickets
  supportTickets: [
    {
      id: 'TKT-001',
      subject: 'Unable to upload business documents',
      merchant: 'Tech Haven Store',
      merchantEmail: 'tech@haven.com',
      status: 'open',
      priority: 'urgent',
      category: 'Technical',
      createdAt: '2024-01-28 14:30',
      lastUpdate: '2024-01-28 14:30',
      assignedTo: null,
      messages: [
        {
          id: 1,
          sender: 'merchant',
          senderName: 'Tech Haven Store',
          message: 'I\'m trying to upload my business license but keep getting an error "File upload failed". I\'ve tried multiple times with different file formats (PDF, JPG) but nothing works.',
          timestamp: '2024-01-28 14:30',
          attachments: []
        }
      ]
    }
  ],
  // NEW: Mock data for Audit Logs
  auditLogs: [
    {
      id: 'LOG-001',
      action: 'merchant_approved',
      actionLabel: 'Merchant Approved',
      user: 'Admin Sarah',
      userId: 'ADM-001',
      userEmail: 'sarah@helpsum.com',
      ipAddress: '192.168.1.100',
      timestamp: '2024-01-28 15:45:32',
      details: {
        merchantId: 'MERCH-123',
        merchantName: 'Tech Haven Store',
        previousStatus: 'pending',
        newStatus: 'approved'
      },
      category: 'merchant_management',
      severity: 'info'
    }
  ]
};

// Check if using mock mode
const isMock = () => API_MODE === 'mock';

// Real API call helper
const apiCall = async (method, endpoint, data = null) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    },
    ...(data && { body: JSON.stringify(data) })
  };

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, options);
    const result = await response.json();
    
    if (!response.ok) {
      throw new Error(result.message || 'API Error');
    }
    
    return result;
  } catch (error) {
    console.error('API Call Error:', error);
    throw error;
  }
};

// ========== API METHODS ==========

export const api = {
  // LOGIN
  login: async (credentials) => {
    if (isMock()) {
      await delay(1000);
      if (credentials.email && credentials.password) {
        const token = 'mock_token_' + Date.now();
        localStorage.setItem(AUTH_TOKEN_KEY, token);
        return { 
          success: true, 
          data: { token, adminDetail: mockData.admin } 
        };
      }
      throw new Error('Invalid credentials');
    }
    
    try {
      const result = await apiCall('POST', '/admin/login', credentials);
      if (result.data?.token) {
        localStorage.setItem(AUTH_TOKEN_KEY, result.data.token);
      }
      return { success: result.status, data: result.data };
    } catch (error) {
      throw new Error(error.message || 'Login failed');
    }
  },

  // LOGOUT
  logout: () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  },

  // CHECK AUTH
  isAuthenticated: () => {
    return !!localStorage.getItem(AUTH_TOKEN_KEY);
  },

  // GET DASHBOARD STATS
  getDashboard: async () => {
    if (isMock()) {
      await delay(800);
      return { success: true, data: mockData.dashboardStats };
    }
    
    try {
      const result = await apiCall('GET', '/admin/dashboard');
      
      // Map real API structure to what app expects
      return { 
        success: result.status, 
        data: {
          totalMerchants: result.data.users?.totalMerchants || 0,
          totalRevenue: result.data.jobs?.totalRevenue || 0,
          totalOrders: result.data.jobs?.totalJobs || 0,
          pendingApprovals: result.data.users?.unverifiedUsers || 0,
          recentUsers: result.data.users?.recentUsers || 0,
          todayUsers: result.data.users?.todayUsers || 0,
          completedJobs: result.data.jobs?.completedJobs || 0,
          
          // Keep full stats for advanced use
          fullStats: result.data
        }
      };
    } catch (error) {
      console.error('Dashboard fetch error:', error);
      throw error;
    }
  },

  // GET MERCHANTS
  getMerchants: async () => {
    if (isMock()) {
      await delay(600);
      return { success: true, data: [...mockData.merchants] };
    }
    
    try {
      const result = await apiCall('GET', '/admin/merchants');
      
      // Map API response to expected format
      const merchants = (result.data || []).map(merchant => ({
        id: merchant._id || merchant.id,
        name: `${merchant.firstName || ''} ${merchant.lastName || ''}`.trim() || 'Unknown',
        owner: `${merchant.firstName || ''} ${merchant.lastName || ''}`.trim() || 'Unknown',
        email: merchant.email || 'N/A',
        phone: merchant.phone || 'N/A',
        category: merchant.category || 'Uncategorized',
        location: merchant.location || merchant.address || 'N/A',
        revenue: '$0', // Calculate from transactions if available
        status: merchant.isVerified ? 'approved' : (merchant.status === false ? 'rejected' : 'pending'),
        rating: merchant.rating || 0,
        joinDate: merchant.createdAt ? new Date(merchant.createdAt).toLocaleDateString() : 'N/A',
        description: merchant.bio || merchant.description || 'No description provided',
        documents: merchant.documents || []
      }));
      
      return { success: result.status, data: merchants };
    } catch (error) {
      console.error('Merchants fetch error:', error);
      throw error;
    }
  },

  // APPROVE MERCHANT
  approveMerchant: async (merchantId) => {
    if (isMock()) {
      await delay(500);
      const merchant = mockData.merchants.find(m => m.id === merchantId);
      if (merchant) merchant.status = 'approved';
      return { success: true, message: 'Merchant approved' };
    }
    
    try {
      const result = await apiCall('POST', '/admin/verify-unverify-user', { id: merchantId });
      return { success: result.status, message: result.message || 'Merchant approved successfully' };
    } catch (error) {
      throw new Error(error.message || 'Failed to approve merchant');
    }
  },

  // REJECT MERCHANT
  rejectMerchant: async (merchantId) => {
    if (isMock()) {
      await delay(500);
      const merchant = mockData.merchants.find(m => m.id === merchantId);
      if (merchant) merchant.status = 'rejected';
      return { success: true, message: 'Merchant rejected' };
    }
    
    try {
      const result = await apiCall('POST', '/admin/active-inactive-user', { id: merchantId, status: false });
      return { success: result.status, message: result.message || 'Merchant rejected successfully' };
    } catch (error) {
      throw new Error(error.message || 'Failed to reject merchant');
    }
  },

  // DELETE MERCHANT
  deleteMerchant: async (merchantId) => {
    if (isMock()) {
      await delay(500);
      const index = mockData.merchants.findIndex(m => m.id === merchantId);
      if (index > -1) mockData.merchants.splice(index, 1);
      return { success: true, message: 'Merchant deleted' };
    }
    
    try {
      const result = await apiCall('DELETE', `/admin/merchants/${merchantId}`);
      return { success: result.status, message: result.message || 'Merchant deleted successfully' };
    } catch (error) {
      throw new Error(error.message || 'Failed to delete merchant');
    }
  },

  // GET NOTIFICATIONS
  getNotifications: async () => {
    if (isMock()) {
      await delay(400);
      return { success: true, data: [...mockData.notifications] };
    }
    
    try {
      const result = await apiCall('GET', '/admin/notifications');
      return { success: result.status, data: result.data || [] };
    } catch (error) {
      console.error('Notifications fetch error:', error);
      return { success: false, data: [] }; // Return empty array on error
    }
  },

  // MARK NOTIFICATION READ
  markNotificationRead: async (notificationId) => {
    if (isMock()) {
      await delay(200);
      const notif = mockData.notifications.find(n => n.id === notificationId);
      if (notif) notif.read = true;
      return { success: true };
    }
    
    try {
      const result = await apiCall('POST', `/admin/notifications/${notificationId}/read`);
      return { success: result.status };
    } catch (error) {
      console.error('Mark notification read error:', error);
      return { success: false };
    }
  },

  // MARK ALL NOTIFICATIONS READ
  markAllNotificationsRead: async () => {
    if (isMock()) {
      await delay(300);
      mockData.notifications.forEach(n => n.read = true);
      return { success: true };
    }
    
    try {
      const result = await apiCall('POST', '/admin/notifications/read-all');
      return { success: result.status };
    } catch (error) {
      console.error('Mark all notifications read error:', error);
      return { success: false };
    }
  },

  // DELETE NOTIFICATION
  deleteNotification: async (notificationId) => {
    if (isMock()) {
      await delay(200);
      const index = mockData.notifications.findIndex(n => n.id === notificationId);
      if (index > -1) mockData.notifications.splice(index, 1);
      return { success: true };
    }
    
    try {
      const result = await apiCall('DELETE', `/admin/notifications/${notificationId}`);
      return { success: result.status };
    } catch (error) {
      console.error('Delete notification error:', error);
      return { success: false };
    }
  },

  // CLEAR ALL NOTIFICATIONS
  clearAllNotifications: async () => {
    if (isMock()) {
      await delay(300);
      mockData.notifications.length = 0;
      return { success: true };
    }
    
    try {
      const result = await apiCall('DELETE', '/admin/notifications');
      return { success: result.status };
    } catch (error) {
      console.error('Clear notifications error:', error);
      return { success: false };
    }
  },

  // ========== NEW: TRANSACTION MANAGEMENT ==========
  
  // GET TRANSACTIONS (for Transaction Management Hub)
  getTransactionsList: async () => {
    // Always use mock data for now (until backend is ready)
    await delay(600);
    return { success: true, data: [...mockData.transactions] };
    
    /* Uncomment when backend is ready:
    try {
      const result = await apiCall('GET', '/admin/transactions-list');
      return { success: result.status, data: result.data || [] };
    } catch (error) {
      console.error('Transactions fetch error:', error);
      return { success: false, data: [] };
    }
    */
  },

  // PROCESS REFUND
  processRefund: async (transactionId, refundData) => {
    // Always use mock data for now
    await delay(500);
    return { success: true, message: 'Refund processed successfully' };
    
    /* Uncomment when backend is ready:
    try {
      const result = await apiCall('POST', '/admin/process-refund', { 
        transactionId, 
        ...refundData 
      });
      return { success: result.status, message: result.message };
    } catch (error) {
      throw new Error(error.message || 'Failed to process refund');
    }
    */
  },

  // RESOLVE DISPUTE
  resolveDispute: async (transactionId, resolution) => {
    // Always use mock data for now
    await delay(500);
    return { success: true, message: 'Dispute resolved successfully' };
    
    /* Uncomment when backend is ready:
    try {
      const result = await apiCall('POST', '/admin/resolve-dispute', { 
        transactionId, 
        resolution 
      });
      return { success: result.status, message: result.message };
    } catch (error) {
      throw new Error(error.message || 'Failed to resolve dispute');
    }
    */
  },

  // ========== NEW: SUPPORT TICKETING ==========
  
  // GET SUPPORT TICKETS
  getSupportTickets: async () => {
    // Always use mock data for now
    await delay(600);
    return { success: true, data: [...mockData.supportTickets] };
    
    /* Uncomment when backend is ready:
    try {
      const result = await apiCall('GET', '/admin/support-tickets');
      return { success: result.status, data: result.data || [] };
    } catch (error) {
      console.error('Support tickets fetch error:', error);
      return { success: false, data: [] };
    }
    */
  },

  // UPDATE TICKET STATUS
  updateTicketStatus: async (ticketId, status) => {
    // Always use mock data for now
    await delay(400);
    return { success: true, message: 'Ticket status updated' };
    
    /* Uncomment when backend is ready:
    try {
      const result = await apiCall('PATCH', `/admin/support-tickets/${ticketId}/status`, { status });
      return { success: result.status, message: result.message };
    } catch (error) {
      throw new Error(error.message || 'Failed to update ticket status');
    }
    */
  },

  // ASSIGN TICKET
  assignTicket: async (ticketId, adminId) => {
    // Always use mock data for now
    await delay(400);
    return { success: true, message: 'Ticket assigned successfully' };
    
    /* Uncomment when backend is ready:
    try {
      const result = await apiCall('PATCH', `/admin/support-tickets/${ticketId}/assign`, { adminId });
      return { success: result.status, message: result.message };
    } catch (error) {
      throw new Error(error.message || 'Failed to assign ticket');
    }
    */
  },

  // SEND TICKET REPLY
  sendTicketReply: async (ticketId, message) => {
    // Always use mock data for now
    await delay(500);
    return { success: true, message: 'Reply sent successfully' };
    
    /* Uncomment when backend is ready:
    try {
      const result = await apiCall('POST', `/admin/support-tickets/${ticketId}/reply`, { message });
      return { success: result.status, data: result.data };
    } catch (error) {
      throw new Error(error.message || 'Failed to send reply');
    }
    */
  },

  // ========== NEW: AUDIT LOGS ==========
  
  // GET AUDIT LOGS
  getAuditLogs: async (filters = {}) => {
    // Always use mock data for now
    await delay(600);
    return { success: true, data: [...mockData.auditLogs] };
    
    /* Uncomment when backend is ready:
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const result = await apiCall('GET', `/admin/audit-logs?${queryParams}`);
      return { success: result.status, data: result.data || [] };
    } catch (error) {
      console.error('Audit logs fetch error:', error);
      return { success: false, data: [] };
    }
    */
  },

  // EXPORT AUDIT LOGS
  exportAuditLogs: async (format = 'csv') => {
    // Always use mock data for now
    await delay(800);
    return { success: true, message: 'Audit logs exported successfully' };
    
    /* Uncomment when backend is ready:
    try {
      const result = await apiCall('POST', '/admin/audit-logs/export', { format });
      return { success: result.status, data: result.data };
    } catch (error) {
      throw new Error(error.message || 'Failed to export audit logs');
    }
    */
  },

  // ========== EXISTING METHODS (UNCHANGED) ==========

  // GET CONSUMERS
  getConsumers: async () => {
    if (isMock()) {
      await delay(500);
      return { success: true, data: [] };
    }
    
    try {
      const result = await apiCall('GET', '/admin/consumers');
      return { success: result.status, data: result.data || [] };
    } catch (error) {
      console.error('Consumers fetch error:', error);
      return { success: false, data: [] };
    }
  },

  // GET TRANSACTIONS (existing - for general use)
  getTransactions: async () => {
    if (isMock()) {
      await delay(500);
      return { success: true, data: [] };
    }
    
    try {
      const result = await apiCall('GET', '/admin/transactions');
      return { success: result.status, data: result.data || [] };
    } catch (error) {
      console.error('Transactions fetch error:', error);
      return { success: false, data: [] };
    }
  },

  // GET JOBS
  getJobs: async () => {
    if (isMock()) {
      await delay(500);
      return { success: true, data: [] };
    }
    
    try {
      const result = await apiCall('GET', '/admin/jobs');
      return { success: result.status, data: result.data || [] };
    } catch (error) {
      console.error('Jobs fetch error:', error);
      return { success: false, data: [] };
    }
  },

  // BLOCK/UNBLOCK USER
  blockUnblockUser: async (userId) => {
    if (isMock()) {
      await delay(400);
      return { success: true, message: 'User status updated' };
    }
    
    try {
      const result = await apiCall('POST', '/admin/block-unblock-user', { id: userId });
      return { success: result.status, message: result.message || 'User status updated' };
    } catch (error) {
      throw new Error(error.message || 'Failed to update user status');
    }
  },

  // ACTIVE/INACTIVE USER
  activeInactiveUser: async (userId, status) => {
    if (isMock()) {
      await delay(400);
      return { success: true, message: 'User status updated' };
    }
    
    try {
      const result = await apiCall('POST', '/admin/active-inactive-user', { id: userId, status });
      return { success: result.status, message: result.message || 'User status updated' };
    } catch (error) {
      throw new Error(error.message || 'Failed to update user status');
    }
  },

  // CREATE USER
  createUser: async (userData) => {
    if (isMock()) {
      await delay(600);
      return { success: true, data: { _id: 'new_' + Date.now(), ...userData } };
    }
    
    try {
      const result = await apiCall('POST', '/admin/user-creation-for-admin', userData);
      return { success: result.status, data: result.data };
    } catch (error) {
      throw new Error(error.message || 'Failed to create user');
    }
  },

  // UPDATE PROFILE
  updateProfile: async (profileData) => {
    if (isMock()) {
      await delay(500);
      return { success: true, message: 'Profile updated' };
    }
    
    try {
      const result = await apiCall('PUT', '/admin/profile', profileData);
      return { success: result.status, message: result.message || 'Profile updated successfully' };
    } catch (error) {
      throw new Error(error.message || 'Failed to update profile');
    }
  },

  // CHANGE PASSWORD
  changePassword: async (passwordData) => {
    if (isMock()) {
      await delay(500);
      return { success: true, message: 'Password changed' };
    }
    
    try {
      const result = await apiCall('POST', '/admin/change-password', passwordData);
      return { success: result.status, message: result.message || 'Password changed successfully' };
    } catch (error) {
      throw new Error(error.message || 'Failed to change password');
    }
  },

  // GET STATS
  getUserStats: async () => {
    if (isMock()) {
      await delay(300);
      return { success: true, data: mockData.dashboardStats };
    }
    
    try {
      const result = await apiCall('GET', '/admin/stats/users');
      return { success: result.status, data: result.data };
    } catch (error) {
      console.error('User stats fetch error:', error);
      return { success: false, data: {} };
    }
  },

  getJobStats: async () => {
    if (isMock()) {
      await delay(300);
      return { success: true, data: {} };
    }
    
    try {
      const result = await apiCall('GET', '/admin/stats/jobs');
      return { success: result.status, data: result.data };
    } catch (error) {
      console.error('Job stats fetch error:', error);
      return { success: false, data: {} };
    }
  },

  getTransactionStats: async () => {
    if (isMock()) {
      await delay(300);
      return { success: true, data: {} };
    }
    
    try {
      const result = await apiCall('GET', '/admin/stats/transactions');
      return { success: result.status, data: result.data };
    } catch (error) {
      console.error('Transaction stats fetch error:', error);
      return { success: false, data: {} };
    }
  }
};

export default api;
